import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  Typography,
} from "@mui/material";

function OptionsFilter({ options, value, onChange, title }) {
  const handleChange = (add, optionValue) => {
    if (add) {
      onChange([...value, optionValue]);
    } else {
      onChange(value.filter((val) => val !== optionValue));
    }
  };

  return (
    <Accordion variant="outlined" sx={{ border: "none" }}>
      <AccordionSummary expandIcon={<ExpandMore />}>{title}</AccordionSummary>
      <AccordionDetails>
        <Box display="flex" flexDirection="column" rowGap="0.5rem">
          {options.map((option) => (
            <Box display="flex" key={option.value} alignItems="center">
              <Checkbox
                checked={value.indexOf(option.value) > -1}
                onChange={(e) => handleChange(e.target.checked, option.value)}
              />
              <Typography>{option.label}</Typography>
            </Box>
          ))}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}

export { OptionsFilter };
